<template>
    <v-container fluid grid-list-xl class="c-container">
        <h5 class="headline c-mb-4">Raumklima</h5>
        <div class="subheading c-mb-2">Status</div>
        <div class="c-fbox elevation-11 c-mb-4">
            <div class="c-fbox--title">
                <i class="caru-icons caru-happy-w"></i>
            </div>
            <div class="c-fbox--text subheading">
                CARU fühlt sich wohl!<br>Das Raumklima ist gut.
            </div>
        </div>
        <v-layout row wrap>
            <v-flex xs12 md6 lg3 style="display: flex">
                <div class="c-mb-3 elevation-11 c-sensor-val">
                    <h4 class="display-1 c-mb-2">{{correctTemp(currentDevice.values.temperature.val,
                        currentDevice.values.temperatureSCD.val)}}° C</h4>
                    <div class="subheading">Temperatur</div>
                </div>
            </v-flex>
            <v-flex xs12 md6 lg3 class="d-flex">
                <div class="c-mb-3 elevation-11 c-sensor-val">
                    <h4 class="display-1 c-mb-2">{{correctHum(currentDevice.values.humidity.val,
                        currentDevice.values.temperature.val,
                        currentDevice.values.temperatureSCD.val)}}%</h4>
                    <div class="subheading">Feuchtigkeit</div>
                </div>
            </v-flex>
            <v-flex xs12 md6 lg3 class="d-flex">
                <div class="c-mb-3 elevation-11 c-sensor-val">
                    <h4 class="display-1 c-mb-2">{{lightText(currentDevice.values.light.val)}}</h4>
                    <div class="subheading">Licht</div>
                </div>
            </v-flex>
            <v-flex xs12 md6 lg3 class="d-flex">
                <div class="c-mb-3 elevation-11 c-sensor-val">
                    <h5 class="headline c-mb-1">CO<sub>2</sub>: {{currentDevice.values.co2.val}} ppm</h5>
                    <h5 class="headline c-mb-2">VOC: {{currentDevice.values.voc.val}} ppb</h5>
                    <div class="subheading">Luftqualität</div>
                </div>
            </v-flex>
        </v-layout>
        <div class="subheading">Letztes Update: {{currentDevice.lastSeen || currentDevice.ts | niceDate}}</div>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapState} = createNamespacedHelpers('device')

export default {
  name: 'RoomConditions',
  data () {
    return {
      editMode: false,
      valid: false,
      recipient: {
        name: 'Frida Hess',
        deviceId: 'p8pnh7j6',
        location: 'Frauenfeld Altersheim 3rd floor, 304',
        responsible: 'Kristina',
        contactPhone: '(123) 444-4444'
      }
    }
  },
  computed: {
    ...mapState({
      currentDevice: state => state.currentDevice,
    })
  },
  created () {},
  methods: {
    correctTemp (tSHT, tSCD) {
      if (tSHT === '?') {
        return tSHT
      }
      let tfSHT = parseFloat(tSHT)
      let tfSCD = parseFloat(tSCD)
      let delta = tfSCD - tfSHT
      if (delta > 1.8) {
        return (tfSHT - 8.9).toFixed(1)
      } else {
        return `Kal.`
      }
    },
    correctHum (h, tSHT, tSCD) {
      let hi = parseFloat(h)
      if (tSHT === '?' || isNaN(hi)) {
        return h
      }

      let tfSHT = parseFloat(tSHT)
      let tfSCD = parseFloat(tSCD)

      let delta = tfSCD - tfSHT
      if (delta > 1.8) {
        let t2 = tfSHT - 8.9
        let lambda = 243.12
        let beta = 17.62
        let rh = Math.round(hi * Math.exp((beta * tfSHT) / (lambda + tfSHT)) / Math.exp((beta * t2) / (lambda + t2)))
        return `${rh}`
      } else {
        return '?'
      }
    },
    lightText (val) {
      if (val === '?') {
        return val
      }
      let light = parseInt(val)
      if (light < 10) {
        return 'Dunkel'
      }
      return 'Hell'
    }
  }
}
</script>
<style lang="scss">
    @import "../../styles/vars";

    .c-fbox {
        display: flex;
        flex-direction: row;
        max-width: 28rem;
        border-bottom-left-radius: 4rem;
        border-top-right-radius: 4rem;

        &--title {
            box-shadow: 11px 0 7px -4px rgba(0, 0, 0, 0.08);
            z-index: 1;
            background-color: $primary-color;
            color: #fff;
            border-bottom-left-radius: 4rem;
            padding: 3rem;
            flex: 1 1 auto;
            line-height: 36px;


            i {
                line-height: 36px;
                width: 36px;
                height: 36px;
            }
        }

        &--text {
            flex: 1 1 auto;
            background-color: $primary-color;
            color: #fff;
            border-top-right-radius: 4rem;
            padding: 2rem 3rem;
        }
    }

    .c-sensor-val {
        background-color: #fff;
        padding: 2rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        align-items: stretch;
        border-radius: $card-radius;

        .subheading {
            padding: 2rem 0 0;
            border-top: 1px solid $grey-lighter;
            flex: 0 1 auto;
        }

        h4, h5 {
            color: $primary-color;
            flex: 1 0 auto;
        }
    }

</style>
